const STORAGE_PREFIX = 'statsUnlock:';
const DEFAULT_TTL_MS = 30 * 60 * 1000;

export const getStatsUnlockStorageKey = (idsalone) => `${STORAGE_PREFIX}${idsalone}`;

export const clearStatsUnlock = (idsalone) => {
  if (idsalone == null || idsalone === '') return;
  try {
    sessionStorage.removeItem(getStatsUnlockStorageKey(idsalone));
  } catch (_) {
    /* ignore */
  }
};

export const clearAllStatsUnlock = () => {
  try {
    const toRemove = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(STORAGE_PREFIX)) toRemove.push(key);
    }
    toRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (_) {
    /* ignore */
  }
};

const pickUnlockToken = (apiData = {}) => {
  const nested = apiData?.data && typeof apiData.data === 'object' ? apiData.data : {};
  const candidates = [
    apiData?.token,
    apiData?.unlockToken,
    apiData?.statsUnlockToken,
    apiData?.accessToken,
    apiData?.jwt,
    nested.token,
    nested.unlockToken,
    nested.statsUnlockToken,
    typeof apiData?.unlock === 'string' ? apiData.unlock : null,
    typeof apiData?.submittedPassword === 'string' ? apiData.submittedPassword : null,
  ];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
  }
  return null;
};

const pickExpiresAt = (apiData = {}) => {
  if (apiData.expiresAt) return Number(apiData.expiresAt);
  if (apiData.expiry) return Number(apiData.expiry);
  if (typeof apiData.expiresIn === 'number') {
    return Date.now() + apiData.expiresIn * 1000;
  }
  return Date.now() + DEFAULT_TTL_MS;
};

export const setStatsUnlock = (idsalone, apiData = {}) => {
  if (idsalone == null || idsalone === '') return;
  const isFallback = Boolean(apiData.fallback);
  const payload = {
    // Sempre un token dopo sblocco riuscito: il BE può non restituirlo
    // e le GET successive resterebbero senza header → 403 / zeri.
    token:
      pickUnlockToken(apiData) ||
      (isFallback ? '__local_fallback__' : '__unlocked__'),
    fallback: isFallback,
    expiresAt: pickExpiresAt(apiData),
  };
  try {
    sessionStorage.setItem(getStatsUnlockStorageKey(idsalone), JSON.stringify(payload));
  } catch (_) {
    /* ignore */
  }
};

export const getStatsUnlock = (idsalone) => {
  if (idsalone == null || idsalone === '') return null;
  try {
    const raw = sessionStorage.getItem(getStatsUnlockStorageKey(idsalone));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.expiresAt || Date.now() > Number(parsed.expiresAt)) {
      clearStatsUnlock(idsalone);
      return null;
    }
    return parsed;
  } catch (_) {
    return null;
  }
};

export const isStatsUnlocked = (idsalone) => Boolean(getStatsUnlock(idsalone));

export const getStatsUnlockToken = (idsalone) => getStatsUnlock(idsalone)?.token || null;

export const getStatsUnlockRequestHeaders = (idsalone) => {
  const token = getStatsUnlockToken(idsalone);
  if (!token) return {};
  const headers = { 'X-Stats-Unlock': token };
  if (token !== '__unlocked__' && token !== '__local_fallback__') {
    headers['X-Stats-Password'] = token;
  }
  return headers;
};

export const salonRequiresStatsPassword = (salon) =>
  Boolean(salon?.passwordStatistiche ?? salon?.password_statistiche);
